<template>
    <q-dialog :model-value="visible" @update:model-value="close" persistent>
      <q-card class="reset-password-modal">
        <q-card-section class="modal-header">
          <h3 class="modal-title">{{ $t("resetPasswordTitle") }}</h3>
          <q-icon name="close" class="close-icon" @click="close" />
        </q-card-section>
        <q-card-section class="modal-content">
          <q-form @submit.prevent="sendResetPassword">
            <q-input
              v-model="email"
              type="email"
              :placeholder="$t('enterEmail')"
              dense
              outlined
              :error="!!errorMessage"
              :error-message="errorMessage"
              @focus="errorMessage = ''"
            />
            <q-btn
              type="submit"
              color="primary"
              :label="$t('sendResetLink')"
              class="submit-btn"
            />
          </q-form>
          <q-banner v-if="successMessage" class="success-banner" type="positive">
            {{ successMessage }}
          </q-banner>
          <q-banner v-if="errorMessage && !successMessage" class="error-banner" type="negative">
            {{ errorMessage }}
          </q-banner>
        </q-card-section>
      </q-card>
    </q-dialog>
  </template>
  
  <script>
  import { QDialog, QCard, QCardSection, QForm, QInput, QBtn, QBanner, QIcon } from 'quasar';
  import AuthService from '@/services/authService';
  
  export default {
    components: {
      QDialog,
      QCard,
      QCardSection,
      QForm,
      QInput,
      QBtn,
      QBanner,
      QIcon,
    },
    props: {
      visible: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        email: '',
        successMessage: '',
        errorMessage: '',
      };
    },
    methods: {
      async sendResetPassword() {
        this.successMessage = '';
        this.errorMessage = '';
        if (!this.email) {
          this.errorMessage = this.$t('emailRequired');
          return;
        }
        try {
          const tenantId = AuthService.getTenantHost();
          await AuthService.sendResetPasswordEmail(this.email, tenantId);
          this.successMessage = this.$t('resetLinkSent');
        } catch (error) {
          this.errorMessage = error.response?.data?.message || error.message || this.$t('resetLinkFailed');
        }
      },
      close() {
        this.$emit('update:visible', false);
      },
    },
  };
  </script>
  
  <style scoped>
  .reset-password-modal {
    max-width: 360px;
    padding: 0;
    border-radius: 6px;
    overflow: hidden;
  }
  
  .modal-header {
    background-color: #f9f9f9;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .modal-title {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    color: #333;
  }
  
  .close-icon {
    cursor: pointer;
    color: #666;
  }
  
  .modal-content {
    padding: 16px;
  }
  
  .submit-btn {
    margin-top: 12px;
    width: 100%;
  }
  
  .success-banner {
    margin-top: 12px;
    font-size: 13px;
  }
  
  .error-banner {
    margin-top: 12px;
    font-size: 13px;
  }
  </style>
  